import apiService from '../apiService';

const END_POINT_NAME = "monthly-expenses";

const MonthlyExpensesService = {
  listMonthlyExpense: (params) => apiService.get(`/${END_POINT_NAME}`, params),
  getMonthlyExpense: (id) => apiService.get(`/${END_POINT_NAME}/${id}`),
  getMonthlyExpenseByYearAndMonth: (year, month) => apiService.get(`/${END_POINT_NAME}/${year}/${month}`),
  getMonthlyExpenseByYear: (year) => apiService.get(`/${END_POINT_NAME}/${year}`),
  getYearlyExpenseByYear: (year) => apiService.get(`/${END_POINT_NAME}/allYear/${year}`),
  getExpenseSummary: (params) => apiService.get(`/${END_POINT_NAME}/expenseSummary`, params),
  createMonthlyExpense: (data) => apiService.post(`/${END_POINT_NAME}`, data),
  updateMonthlyExpense: (id, data) => apiService.put(`/${END_POINT_NAME}/${id}`, data),
  deleteMonthlyExpense: (id) => apiService.delete(`/${END_POINT_NAME}/${id}`),
};

export default MonthlyExpensesService;
